import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name
})
var crud = new Crud('RequisitionsMailboxes', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  requisitionsMailboxes: []
}

const mutations = {
  ...crud.mutations,
  DELETE_RECEPTION (state, payload) {
    const idx = state.requisitionsMailboxes.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.requisitionsMailboxes, idx)
    }
  }
}

const actions = {
  ...crud.actions,
  async deleteRequisition ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`requisitions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RECEPTION', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.requisitions', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalSummaryVisible ({ commit }, payload) {
    commit('PurchaseOrders/SET_MODAL_SUMMARY_VISIBLE', payload, { root: true })
  },
  setModalImportRequisitionDetailVisible ({ commit }, payload) {
    commit('Requisitions/SET_MODAL_IMPORT_REQUISITION_DETAIL_VISIBLE', payload, { root: true })
  }
}

const getters = {
  ...crud.getters,
  requisitionsMailboxes: state => state.requisitionsMailboxes
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
